module.exports = __webpack_public_path__ + "static/media/horse-riding.c122f4fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse-riding.svg
// module id = 617
// module chunks = 0